import React from "react";
import {
  FormControl,
  Flex,
  FormLabel,
  Checkbox,
  Switch,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";

import { IFormField } from "./fieldTypes";

/**
 * JsonForm Checkbox / Switch Field component.
 * @param props see {@link IFormField}
 */
function CheckboxField({
  field,
  isRequired,
  register,
  disabled = false,
  errorMessage = "",
}: IFormField) {
  let checkbox;
  if (field.inputType === "checkbox") {
    checkbox = (
      <Checkbox
        {...register(field.fieldName, field.config)}
        disabled={disabled}
      />
    );
  } else if (field.inputType === "switch") {
    checkbox = (
      <Switch
        {...register(field.fieldName, field.config)}
        disabled={disabled}
      />
    );
  } else return null;

  return (
    <FormControl isRequired={isRequired} isInvalid={!!errorMessage}>
      <Flex direction="row" alignContent="center" gap="8px" marginBottom="8px">
        <FormLabel style={{ margin: 0 }}>{field.label}</FormLabel>
        {checkbox}
      </Flex>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
      {!errorMessage && field.helperText && (
        <FormHelperText>{field.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export { CheckboxField };
